import { AppFunctionComponent } from "../../types"
import React, { useContext } from "react"
import styled, { css } from "styled-components"
import { Quote as QuoteProps } from "../../types"
import { Quote } from "../../components/common/general-styles.component"
import RichText from "../rich-text/rich-text.resolver"
import { FootnoteContext } from "../../templates/page.template"

const QuoteWrapper = styled(Quote)<{ customStyle: QuoteProps["style"] }>`
  > *:not(cite) {
    max-width: ${({ customStyle }) =>
      customStyle?.text_max_width
        ? `${customStyle?.text_max_width}px`
        : "auto"};
    margin: 0 auto;
  }

  img {
    max-height: 53px;
    max-width: 120px;
    margin-top: 50px !important;
  }

  ${({ customStyle }) =>
    customStyle?.color &&
    css`
      background-color: ${customStyle?.color};

      &:before {
        filter: invert(0.5);
        opacity: 0.8;
      }

      cite {
        color: black;
      }
    `}
`

const QuoteResolver: AppFunctionComponent<QuoteProps> = ({
  text,
  author,
  style,
  className,
}) => {
  const footnotesOptions = useContext(FootnoteContext)

  return (
    <QuoteWrapper className={className} customStyle={style}>
      {text && <RichText content={text} options={footnotesOptions} />}
      {author && <cite>{author}</cite>}
    </QuoteWrapper>
  )
}

export default QuoteResolver
